var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.22 27L55.22 83L34.58 64.95L28 72.48L49.61 91.39C51.25 92.83 53.35 93.62 55.52 93.62H56.22L56.26 93.59C56.6 93.56 56.94 93.51 57.27 93.45C60.03 92.91 62.33 91.16 63.58 88.64L92.17 31.47L83.22 27Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckLight);
export default __webpack_public_path__ + "static/media/Check_Light.685cf795.svg";
export { ForwardRef as ReactComponent };